import { BlockStepManagerComponent, BlockStepManagerComponentProps } from './blockStepManager.component';
import { BlockStepManagerProvider } from './blockStepManager.provider';

interface BlockStepManagerProps extends BlockStepManagerComponentProps {
	// it will automatically render a provider to manage the state internally.
	// If true, you'll need to implement the <BlockStepManagerProvider /> higher in the tree to properly work.
	withoutProvider?: boolean;
}

export const BlockStepManager = ({ withoutProvider, ...componentProps }: BlockStepManagerProps) => {
	return withoutProvider ? (
		<BlockStepManagerComponent {...componentProps} />
	) : (
		<BlockStepManagerProvider>
			<BlockStepManagerComponent {...componentProps} />
		</BlockStepManagerProvider>
	);
};
